<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog" :close-on-click-modal="false">
        <el-form ref="formValidate" :model="model" label-width="120px">
            <el-form-item label="平台ID：" prop="system_id">
                <span>{{model.system_id}}</span>
            </el-form-item>
            <el-form-item label="三方平台用户名：" prop="third_username">
                <span>{{model.third_username}}</span>
            </el-form-item>
            <el-form-item label="本平台用户名：" prop="username">
                <span>{{model.username}}</span>
            </el-form-item>
            <el-form-item label="状态：" prop="state">
                <span>{{model.state}}</span>
            </el-form-item>
            <el-form-item label="添加时间：" prop="add_time">
                <span>{{model.add_time}}</span>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="closeDialog" size="medium">关 闭</el-button>
        </div>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'
import { saveModel } from '@/api/common'

export default {
    name: 'singleSignOnInfo',
    mixins: [editutil],
    data() {
        return {
            model: {
                system_id: '',
                third_username: '',
                username: '',
                state: '',
                add_time: '',
            },
            getObj:{
                url:'/api/admin/singlesignon/info',
                data:{
                    key:'id',
                    value:''
                }
            },
            enu_name: [],
        };
    },
    methods: {}
};
</script>